import axios from '../index'
///create crn
export default { 
    createCrn (payload) {
        return axios.post('/crns/store', payload)
    },

    //update crn
    updateCrn (payload) {
        return axios.post('/crns/update', payload)
    },

    //delete crn /crns/delete/id
    deleteCrn (id) {
        return axios.post('/crns/delete/' + id)
    },

    //delete crn /crns/listado
    listadoCrn (institucionId, params) {
        return axios.get('/crns/list/' + institucionId, {
            params
        })
    }
}